export const faqs = [
  {
    id: 1,
    question: "Which dental treatments are available at Olive Dental Clinic?",
    answer:
      "Olive Dental Clinic provides comprehensive dental care including Root Canal Treatment, Dental Implants, Teeth Cleaning, Cosmetic Dentistry and General Dentistry."
  },
  {
    id: 2,
    question: "Do I need to book an appointment before visiting?",
    answer:
      "Yes. We recommend booking an appointment in advance to reduce waiting time and ensure doctor availability."
  },
  {
    id: 3,
    question: "Do you provide Root Canal Treatment?",
    answer:
      "Yes. We provide advanced Root Canal Treatment using modern techniques for comfortable and effective care."
  },
  {
    id: 4,
    question: "Do you provide Dental Implants?",
    answer:
      "Yes. Olive Dental Clinic offers advanced dental implant solutions for replacing missing teeth."
  },
  {
    id: 5,
    question: "Do you treat children?",
    answer:
      "Yes. We provide dental care for children as well as adults in a comfortable and friendly environment."
  },
  {
    id: 6,
    question: "Which branches does Olive Dental Clinic have?",
    answer:
      "Olive Dental Clinic has branches at Mangalam, Koottayi and Vettom in Malappuram district."
  },
  {
    id: 7,
    question: "How can I book an appointment?",
    answer:
      "You can book an appointment through our website or contact the respective branch directly by phone or WhatsApp."
  },
  {
    id: 8,
    question: "Do you offer teeth cleaning and smile makeover treatments?",
    answer:
      "Yes. We provide professional teeth cleaning, cosmetic dentistry and smile enhancement treatments."
  },
  {
    id: 9,
    question: "What are the working hours of Olive Dental Clinic?",
    answer:
      "Working hours may vary by branch. Please check the selected branch details or contact the clinic before visiting."
  },
  {
    id: 10,
    question: "Do you provide emergency dental care?",
    answer:
      "Please contact the nearest Olive Dental Clinic branch to check the availability of emergency dental care."
  },
  {
    id: 11,
    question: "Is Olive Dental Clinic affordable?",
    answer:
      "Olive Dental Clinic provides quality dental treatments with transparent treatment planning and pricing."
  },
  {
    id: 12,
    question: "Do you accept medical insurance?",
    answer:
      "Please contact the respective branch to know whether your insurance provider is accepted."
  },
  {
    id: 13,
    question: "How do I choose the right branch?",
    answer:
      "You can choose the branch nearest to your location based on your convenience and appointment availability."
  },
  {
    id: 14,
    question: "Do you have digital X-ray facilities?",
    answer:
      "Yes. Olive Dental Clinic uses advanced digital X-ray technology for accurate diagnosis with minimal radiation."
  },
  {
    id: 15,
    question: "Where is Olive Dental Clinic located in Malappuram?",
    answer:
      "Olive Dental Clinic has branches at Mangalam, Koottayi and Vettom. Each branch location is available on our website."
  }
];

// ============================================================
// HELPER FUNCTIONS
// ============================================================

// Get FAQ by ID
export const getFAQById = (id) =>
  faqs.find((faq) => faq.id === id);

// Get total FAQ count
export const getFAQCount = () =>
  faqs.length;

// Get all FAQ questions (for search/display)
export const getAllFAQQuestions = () =>
  faqs.map((faq) => faq.question);

// Search FAQs by keyword
export const searchFAQs = (keyword) =>
  faqs.filter((faq) =>
    faq.question.toLowerCase().includes(keyword.toLowerCase()) ||
    faq.answer.toLowerCase().includes(keyword.toLowerCase())
  );